// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { FilterToggleGroup } from '@/components/filter-toggle-group';
import { COST_VIEW_MODE_OPTIONS } from '@/costs/constants/view-mode-options';
import { TrackingViewMode } from '@/report/types';

interface Props {
  /**
   * The current view mode.
   */
  value: TrackingViewMode;

  /**
   * Callback fired when the view mode changes.
   */
  onChange: (viewMode: TrackingViewMode) => void;
}

/**
 * A toggle button group for switching between cost tracking view modes.
 */
export function CostViewModeToggle(props: Props) {
  return (
    <FilterToggleGroup
      value={props.value}
      options={COST_VIEW_MODE_OPTIONS}
      onChange={props.onChange}
      ariaLabel="Cost view mode"
    />
  );
}
